import { GatsbyImage } from "gatsby-plugin-image";

import { Box, BoxProps } from "@vinomofo/components";

import type { Badge as BadgeType, ResponsiveValue } from "../../types";
import { AwardBadge } from "../award-badge";
import { useResponsiveValue } from "../../hooks/use-match-media";

export interface BadgeStackProps extends BoxProps {
  badges: Array<BadgeType>;
  overlap?: boolean;
  badgeSize?: ResponsiveValue<string | number>;
  horizontal?: ResponsiveValue<boolean>;
  hideCount?: boolean;
  limit?: number;
  gap?: ResponsiveValue<string | number>;
}

export const BadgeStack = ({
  badges,
  badgeSize,
  overlap = true,
  gap = overlap ? "-10px" : "0",
  horizontal: isHorizontal = true,
  hideCount = false,
  limit = 3,
  ...rest
}: BadgeStackProps): JSX.Element => {
  const horizontal = useResponsiveValue(isHorizontal);
  const spacing = gap;

  return (
    <Box display="flex" flexDirection={horizontal ? "row" : "column"} {...rest}>
      {badges
        .filter((badge, i) => !!badge.image)
        .filter((badge, i) => i <= limit - 1)
        .map(({ count, image }, i) => {
          return (
            <AwardBadge
              key={i}
              count={!hideCount && count}
              size={badgeSize}
              marginTop={i !== 0 && !horizontal ? spacing : "0"}
              marginLeft={i !== 0 && horizontal ? spacing : "0"}
            >
              {image && <GatsbyImage image={image} alt="" />}
            </AwardBadge>
          );
        })}
    </Box>
  );
};
